import { reactive } from 'vue'

export const erandid = reactive({
  kuva: false
})